import { AxiosHttpServiceBuilder } from '@wallbox/http'
import { wapiOrganizationRepositoryBuilder } from './WapiOrganizationRepository'

export const wapiOrganizationRepository = () => {
  return wapiOrganizationRepositoryBuilder({
    httpService: new AxiosHttpServiceBuilder()
  })
}
